module.exports = __webpack_public_path__ + "static/img/strategy_tit.2a7dd5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/strategy_tit.png
// module id = yZ8z
// module chunks = 0